import React from 'react';
import { LotsPurchaseTabProps } from './LotsPurchaseTab.type';
import { PurchaseLot } from '../../../../../types/entities';
import Lot from './components/Lot';
import flow from 'lodash/flow';

const LotsPurchaseTab: React.FC<LotsPurchaseTabProps> = ({
    purchase,
    reference,
}) => {
    if (!purchase.lots || !purchase.lots.length) {
        return null;
    }

    return (
        <>
            {purchase.lots.map((lot: PurchaseLot) => {
                return (
                    <Lot
                        key={lot.id}
                        purchase={purchase}
                        reference={reference}
                        lot={lot}
                    />
                );
            })}
        </>
    );
};

export default flow(() => LotsPurchaseTab)();
